
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { useCatalog, useMetadataCatalog } from "@/store";
import { defineComponent } from "@vue/composition-api";
import { zipObject } from "lodash";
import { mapState } from "pinia";
import config from "@/util/constants";

export default defineComponent({
  name: "AddDataCat",
  data: () => ({
    schemaTbl: new Array<any>(),
    dataNameTbl: new Array<any>(),
    regionTbl: new Array<any>(),
    datasetTypeTbl: new Array<any>(),
    dataStatusTbl: new Array<any>(),
    teamTbl: new Array<any>(),
    providerCatTbl: new Array<any>(),
    spatialCatTbl: new Array<any>(),

    // schemaTblN: "schema",
    // dataNameTblN: "data_name",
    // regionTblN: "region",
    // datasetTypeTblN: "dataset_type",
    // dataStatusTblN: "data_status",
    // teamTblN: "team",
    // providerCatTblN: "provider_cat",
    // spatialCatTblN: "spatial_cat",
    // dataCatTblN: "data_cat",
    // tblPath: "/data_mgmt/all/System/",

    schemaTblN: config.metaCat.v_schema,
    dataNameTblN: config.metaCat.v_data_name,
    regionTblN: config.metaCat.v_region,
    datasetTypeTblN: config.metaCat.v_dataset_type,
    dataStatusTblN: config.metaCat.v_data_status,
    teamTblN: config.metaCat.v_team,
    providerCatTblN: config.metaCat.v_provider_cat,
    spatialCatTblN: config.metaCat.v_spatial_cat,
    dataCatTblN: config.metaCat.v_data_cat,
    tblPath: "/meta_cat/",

    dataCatEntry: {
      schema_id: { val: null, type: Number, isRequired: true },
      data_name_id: { val: null, type: Number, isRequired: true },
      region_id: { val: null, type: Number, isRequired: true },
      dataset_type_id: { val: null, type: Number, isRequired: true },
      data_status_id: { val: null, type: Number, isRequired: true },
      data_owner_team_id: { val: null, type: Number, isRequired: true },
      has_pii: { val: null, type: Boolean, isRequired: true },
      created_date: { val: null, type: String, isRequired: false },
      has_geometry: { val: null, type: Boolean, isRequired: true },
      provider_cat_id: { val: null, type: Number, isRequired: true },
      dataset_name: { val: null, type: String, isRequired: true },
      spatial_cat_id: { val: null, type: Number, isRequired: true },
    },

    dpRequest: {} as IDataProviderRequest,
  }),
  computed: {
    ...mapState(useCatalog, ["tableMeta", "tableData"]),
    ...mapState(useMetadataCatalog, ["dataCatUri", "selectedDataCatId"]),
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.dpRequest.filter = [];
      this.dpRequest.orderBys = [];
      await this.catalogChange(this.schemaTblN);
      this.dpRequest.orderBys = [{ columnName: "data_name", keyword: "asc" }];
      await this.catalogChange(this.dataNameTblN);
      this.dpRequest.orderBys = [];
      await this.catalogChange(this.regionTblN);
      await this.catalogChange(this.datasetTypeTblN);
      await this.catalogChange(this.dataStatusTblN);
      await this.catalogChange(this.teamTblN);
      this.dpRequest.orderBys = [
        { columnName: "provider_name", keyword: "asc" },
      ];
      await this.catalogChange(this.providerCatTblN);
      this.dpRequest.orderBys = [];
      await this.catalogChange(this.spatialCatTblN);
    },
    async loadData(tableName: string, columns: Array<string>) {
      await useCatalog()
        .getTableData({
          catalogUri: this.tblPath + tableName,
          request: this.dpRequest,
        })
        .then(() => this.setTableData(tableName, columns));
    },
    setTableData(tableName: string, columns: Array<string>) {
      if (this.tableData?.rows.length) {
        switch (tableName) {
          case this.schemaTblN:
            this.schemaTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.dataNameTblN:
            this.dataNameTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.regionTblN:
            this.regionTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.datasetTypeTblN:
            this.datasetTypeTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.dataStatusTblN:
            this.dataStatusTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.teamTblN:
            this.teamTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.providerCatTblN:
            this.providerCatTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.spatialCatTblN:
            this.spatialCatTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          default:
            this.showMessage(
              "danger",
              "Table name is not matching!! - " + tableName
            );
            break;
        }
      }
    },
    async catalogChange(tableName: string) {
      // Retrieve table meta
      await useCatalog()
        .getTableMeta({
          catalogUri: this.tblPath + tableName,
          request: {},
        })
        .then(() => {
          this.setTableColumns(tableName);
        });
    },
    setTableColumns(tableName: string) {
      if (this.tableMeta?.columns.length) {
        let columns = this.tableMeta.columns.map(
          (c: { columnName: string }) => c.columnName
        );
        this.loadData(tableName, columns);
      }
    },
    async updateDB(param: string) {
      const methodN = "updateDB";
      const requestFrom = "data_cat";
      const nextPage = "data_reference_cat";
      const catUri = this.tblPath + this.dataCatTblN;

      this.$emit(
        methodN,
        requestFrom,
        param,
        this.dataCatEntry,
        nextPage,
        catUri,
        this.dataCatUri
      );
    },
    showMessage(type: string, msg: string) {
      this.$root.$emit("showAlert", 4, type, msg);
    },
  },
});
